import { RefObject } from 'react';
import FeatureTable from '@arcgis/core/widgets/FeatureTable';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import TableTemplate from '@arcgis/core/widgets/FeatureTable/support/TableTemplate';
import { columnTemplates } from '../config/columnTemplate.config';
import store from '../store/store';
import { setGenusTableLoaded } from '../store/slices/adminSlice';

export enum OperationType {
  Add = 'add',
  Update = 'update',
}
export interface IFeatureParams {
  layer: __esri.FeatureLayer;
  features: any;
  type?: OperationType;
}

class GenusTableController {
  private genusSampleLayer: FeatureLayer;
  private genusFeatureTable: FeatureTable | null;

  constructor() {
    this.genusSampleLayer = new FeatureLayer();
    this.genusFeatureTable = new FeatureTable();
  }

  // getters
  getGenusSampleFeatureLayer = () => this.genusSampleLayer;

  initializeTableController = async (domRef: RefObject<HTMLDivElement>, genusUrl: string) => {
    const element = document.createElement('div');
    element.id = 'genus-table';
    domRef.current?.appendChild(element);

    this.genusSampleLayer = new FeatureLayer({
      url: genusUrl,
    });

    this.genusFeatureTable = new FeatureTable({
      editingEnabled: true,
      visibleElements: {
        header: true,
        selectionColumn: true,
        menu: true,
      },
    });

    await this.genusSampleLayer.load();
    const tableTemplate = new TableTemplate({
      columnTemplates: columnTemplates,
    });

    this.genusFeatureTable.layer = this.genusSampleLayer;
    this.genusFeatureTable.tableTemplate = tableTemplate;
    this.genusFeatureTable.container = element;

    this.genusFeatureTable.when((value: any) => {
      if (value.state === 'ready') {
        store.dispatch(setGenusTableLoaded(true));
      }
    });
  };

  addFeatureData = async (params: IFeatureParams) => {
    const { layer, features, type } = params;
    try {
      let response;
      if (type === OperationType.Add) {
        response = await layer.applyEdits({ addFeatures: features });
      } else if (type === OperationType.Update) {
        response = await layer.applyEdits({ updateFeatures: features });
      }
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error('error', error);

      return {
        success: false,
        data: error,
      };
    }
  };
  refreshTable = async () => {
    if (this.genusSampleLayer) {
      this.genusSampleLayer.refresh();
    }
  };
  destroyTable = () => {
    this.genusFeatureTable?.destroy();
    this.genusFeatureTable = null;
  };
}

const genusTableController = new GenusTableController();

export default genusTableController;
